import { useCallback, useState } from 'react';
import type { WorkspaceSearchFull } from '@trinity/chat';
import {
  SearchLoadingAllContext, SearchLoadingBrandContext, SearchLoadingDashboardContext, SearchLoadingQuantAnalysesContext, SearchLoadingDispatchContext, SearchLoadingFileContext,
  SearchLoadingFolderContext, SearchLoadingResetContext,
  SearchLoadingTranscriptContext, SearchLoadingProjectContext,
} from './Context';
import type { SearchLoadingContextState } from './interfaces';

export default function Loading({ children }: ChildrenProps) {
  const [state, dispatch] = useState<SearchLoadingContextState>(getInitialState());

  const reset = useCallback((_: WorkspaceSearchFull.SearchTab) => {
    // dispatch(prev => ({
    //   ...prev,
    //   [tab]: { untouched: true, loading: true },
    // }));
    dispatch(getInitialState());
  }, []);

  return (
    <SearchLoadingDispatchContext.Provider value={dispatch}>
      <SearchLoadingResetContext.Provider value={reset}>
        <SearchLoadingAllContext.Provider value={state.all}>
          <SearchLoadingFileContext.Provider value={state.files}>
            <SearchLoadingFolderContext.Provider value={state.folders}>
              <SearchLoadingBrandContext.Provider value={state.brands}>
                <SearchLoadingDashboardContext.Provider value={state.dashboards}>
                  <SearchLoadingQuantAnalysesContext.Provider value={state.quantanalyses}>
                    <SearchLoadingTranscriptContext.Provider value={state.transcripts}>
                      <SearchLoadingProjectContext.Provider value={state.projects}>
                        {children}
                      </SearchLoadingProjectContext.Provider>
                    </SearchLoadingTranscriptContext.Provider>
                  </SearchLoadingQuantAnalysesContext.Provider>
                </SearchLoadingDashboardContext.Provider>
              </SearchLoadingBrandContext.Provider>
            </SearchLoadingFolderContext.Provider>
          </SearchLoadingFileContext.Provider>
        </SearchLoadingAllContext.Provider>
      </SearchLoadingResetContext.Provider>
    </SearchLoadingDispatchContext.Provider>
  );
}

function getInitialState(): SearchLoadingContextState {
  return {
    all: { untouched: true, loading: true },
    files: { untouched: true, loading: true },
    folders: { untouched: true, loading: true },
    brands: { untouched: true, loading: true },
    dashboards: { untouched: true, loading: true },
    quantanalyses: { untouched: true, loading: true },
    transcripts: { untouched: true, loading: true },
    projects: { untouched: true, loading: true },
  };
}

export { Loading };
